import React, {FC} from 'react';
import {z} from "zod";
import PullOverForm from "@components/pullover/PullOverForm.component";
import {ImplementFormProps} from "@components/form/Form.component";
import {CreateTierInput, CreateTierMutation} from "@src/gql-schema";
import {FormFields} from "@components/form/fields/FormField.component";
import useGql from "@modules/graphql/useGql";


const TierCreateForm: FC<ImplementFormProps<CreateTierMutation> & {
    subscriptionId: string,
    openState: [boolean, React.Dispatch<React.SetStateAction<boolean>>]
}> = ({
    onSubmitSuccess,
    subscriptionId,
    openState
}) => {


    const gql = useGql();

    const fields: FormFields<Omit<CreateTierInput, 'subscriptionId'>> = {
        title: {
            zodType: z.string().min(1).max(64),
            fieldType: 'input',
            label: 'Tier Name',
            description: 'Name of your tier'
        },
        price: {
            zodType: z.number(),
            fieldType: 'input',
            label: 'Price',
            description: 'Price excluding VAT'
        },
        description: {
            zodType: z.string().min(1).max(64),
            fieldType: 'textarea',
            label: 'Tier description'
        },
    }

    return (
        <>
            <PullOverForm
                title={'Tier test form'}
                openState={openState}
                submit={{
                    title: 'Save'
                }}
                cancel={{
                    title: 'Cancel'
                }}
                form={{
                    submit: gql.CreateTier,
                    onSubmitSuccess: onSubmitSuccess,
                    fields,
                    payloadInjection: {
                        subscriptionId
                    }
                }}
            />
        </>
    );
};

export default TierCreateForm;
